import $ from 'jquery';
import flickity from 'flickity';

import 'flickity-as-nav-for';
import 'flickity-bg-lazyload';
import 'flickity-imagesloaded';

$('.carousel').each(function() {
    var carousel = $(this),
        carouselOptions = {
            arrowShape:
                "M95.5436011,45.2640488 L15.2074613,45.2640488 L36.954688,23.6017723 C38.6926835,21.8705657 38.6926835,19.0296114 36.954688,17.2984049 C35.2166924,15.5671984 32.4091611,15.5671984 30.6711655,17.2984049 L1.30349668,46.5513563 C-0.434498894,48.2825628 -0.434498894,51.0791272 1.30349668,52.8103337 L30.6711655,82.0632851 C32.4091611,83.7944916 35.2166924,83.7944916 36.954688,82.0632851 C38.6926835,80.3320786 38.6926835,77.5355142 36.954688,75.8043076 L15.2074613,54.1420311 L95.5436011,54.1420311 C97.9946205,54.1420311 100,52.1444851 100,49.70304 C100,47.2615948 97.9946205,45.2640488 95.5436011,45.2640488 Z",
            cellSelector: '.carousel__slide',
            imagesLoaded: true
        };

    // Thumb carousels
    if(carousel.is('[data-flickity-as-nav-for]')) {
        $.extend(true, carouselOptions, {
            asNavFor: carousel.data('flickity-as-nav-for'),
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            cellAlign: "left"
        });
    }

    // Intro carousels
    if (carousel.hasClass('carousel--intro') && !carousel.hasClass('carousel--thumbs')) {
        $.extend(true, carouselOptions, {
            contain: true,
            pageDots: false,
        });
    }

    // Banner carousels
    if (carousel.hasClass('carousel--banner') || carousel.hasClass('carousel--banner-nav'))  {
        $.extend(true, carouselOptions, {
            wrapAround: true,
            pageDots: false,
            cellAlign: "left",
        });
    }

    // Model carousels
    if (carousel.hasClass('carousel--model') || carousel.hasClass('carousel--model-nav'))  {
        $.extend(true, carouselOptions, {
            wrapAround: true,
            pageDots: false,
            cellAlign: "left",
        });
    }

    // Watch css carousels
    if (carousel.hasClass('carousel--watch-css')) {
        $.extend(true, carouselOptions, {
            watchCSS: true,
        });
    }

    // Instantiate
    new flickity(this, carouselOptions);
});
